/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Description1Inputs */

const en_settings_casmanagement_description1 = /** @type {(inputs: Settings_Casmanagement_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage funds that can provide access their LPs Capital Account Statements and their templates`)
};

/**
* | output |
* | --- |
* | "Manage funds that can provide access their LPs Capital Account Statements and their templates" |
*
* @param {Settings_Casmanagement_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_description1 = /** @type {((inputs?: Settings_Casmanagement_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_description1(inputs)
});
export { settings_casmanagement_description1 as "settings_casManagement_description" }